import React, { Component } from 'react'
import PreFooter from './PreFooter'
import SectionFooter from './SectionFooter'

class Footer extends Component {
  render() {
    const { config } = this.props
    const url = config.siteRss
    const { copyright } = config
    if (!copyright) {
      return null
    }
    return (
      <footer className="footer">
        <PreFooter />
        <SectionFooter />
      </footer>
    )
  }
}

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.jsx